import { useState } from 'react';
import { DataTable, Page, Card } from '@shopify/polaris';
import SettingsAddEditModal, { getSettingsEditLink } from '../../settingsAddEditModal';
import { openAddModal } from '../../../../shared/components/settingsFunctions.js';
import { truncate } from '../../../../shared/components/functions.jsx';
import Toasts from '../../../../shared/components/toasts/toasts.jsx';
import { useLookupStore } from '../../../../context/useStore.js';
import { useToggle } from '../../../../shared/useToogle.js';

export default function SettingsPaymentConditionsPage() {
  const [paymentconditions, setPaymentconditions] = useLookupStore((state) => [state.paymentconditions, state.setPaymentconditions]);
  const [modalOpen, setModalOpen] = useToggle(false);
  const [entryId, setEntryId] = useState('');
  const [isAdd, setIsAdd] = useState(true);
  const [entry, setEntry] = useState({
    betalingNL: { type: 'text', label: 'NL', max: '50', multi: true, value: '' },
    betalingFR: { type: 'text', label: 'FR', max: '50', multi: true, value: '' },
    betalingDE: { type: 'text', label: 'DE', max: '50', multi: true, value: '' },
    betalingUK: { type: 'text', label: 'EN', max: '50', multi: true, value: '' }
  });
  const [toast, setToast] = useState(false);
  const [errorToast, setErrorToast] = useState(false);

  const url = '/api/paymentconditions';
  const title = 'Payment conditions';

  const rows = paymentconditions.map((item) => {
    return [
      truncate(item.betalingNL, 20, false),
      truncate(item.betalingFR, 20, false),
      truncate(item.betalingDE, 20, false),
      truncate(item.betalingUK, 20, false),
      getSettingsEditLink(setModalOpen, entry, setEntry, setIsAdd, setEntryId, item, item.betalingID)
    ];
  });

  return (
    <Page
      title={title}
      fullWidth
      backAction={{ content: 'Settings', url: '/settings' }}
      primaryAction={{ content: 'Add payment conditions', onAction: async () => openAddModal(setModalOpen, entry, setEntry, setIsAdd, setEntryId) }}
    >
      <SettingsAddEditModal
        modalTitle={title}
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        isAdd={isAdd}
        entry={entry}
        setEntry={setEntry}
        entryId={entryId}
        url={url}
        setToast={setToast}
        setErrorToast={setErrorToast}
        setItems={setPaymentconditions}
      />
      <Toasts toast={toast} setToast={setToast} errorToast={errorToast} setErrorToast={setErrorToast} />
      <Card>
        <DataTable
          stickyHeader
          increasedTableDensity
          verticalAlign="middle"
          columnContentTypes={['text', 'text', 'text', 'text', 'numeric']}
          headings={[<b>NL</b>, <b>FR</b>, <b>DE</b>, <b>EN</b>, <b>Edit</b>]}
          rows={rows}
        />
      </Card>
    </Page>
  );
}
